module.exports = __webpack_public_path__ + "static/media/MHRP09N0019.49f13c53.svg";